// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. USE component-icon/src/svgtoreact.sh TO MODIFY
import React from 'react';
import PropTypes from 'prop-types';

var ExternalLink = function ExternalLink(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      className: className,
      "aria-label": label,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16"
    },
    /*#__PURE__*/
    React.createElement("path", {
      d: "M13.75 7.65a.625.625 0 00-.625.625v4.85H2.875V2.875h4.85a.625.625 0 000-1.25H2.25a.625.625 0 00-.625.625v11.5a.625.625 0 00.625.625h11.5a.625.625 0 00.625-.625V8.275a.625.625 0 00-.625-.625z"
    }),
    /*#__PURE__*/
    React.createElement("path", {
      d: "M14.192 1.808a.629.629 0 00-.442-.183h-2.741a.625.625 0 000 1.25h1.138l-4.7 4.7a.625.625 0 10.884.884l4.792-4.793v1.325a.625.625 0 101.25 0V2.25a.629.629 0 00-.181-.442z"
    }))
  );
};

export default ExternalLink;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-icon/es/reactsvgs/ExternalLink.js
// module id = 1005
// module chunks = 0